export enum ItemFamily {
  Halloween = 'halloween',
  Christmas = 'christmas',
  Fusion = 'fusion'
}

export interface ItemDef {
  key: string;
  family: ItemFamily;
  /** Base point value before combo multiplier. */
  points: number;
}

export interface LevelConfig {
  id: number;
  name: string;
  /** Total number of items spawned before the level ends. */
  itemCount: number;
  /** Milliseconds between item spawns. */
  spawnIntervalMs: number;
  /** Pixels per second the items fall. */
  fallSpeed: number;
  /** Controls which item families have been introduced at this point. */
  itemPool: 'starter' | 'core' | 'full';
  /** Score required for 1 / 2 / 3 stars. */
  starThresholds: [number, number, number];
}

export interface LevelResult {
  levelId: number;
  score: number;
  stars: number;
  bestCombo: number;
}
